module.exports = __webpack_public_path__ + "static/media/next.e4ba9029.svg";